import React, { useState } from "react";
import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const models = [
  { name: "Minimal", category: "Display", image: "images/newminimal1.jpg", description: "Minimalistic design with powerful features, perfect for small and intimate coffee spaces.", route: "/minimal" },
  { name: "Fresco Combi", category: "Semi-Verticals", image: "images/fresco.jpg", description: "An innovative model that combines modern display techniques with ergonomic functionality.", route: "/FrescoCombi-lower" },
  { name: "United", category: "Multi decks", image: "images/united.png", description: "A multi-functional model that is perfect for busy coffee shops and bakeries with diverse needs.", route: "/united" },
  { name: "Iris", category: "Display", image: "images/newiris.jpg", description: "Sleek, contemporary display with a focus on simplicity and functionality for any coffee space.", route: "/iris" },
  { name: "Daisy", category: "Display", image: "images/newdaisy.jpg", description: "An elegant, user-friendly model, designed to fit in both modern and classic coffee shops.", route: "/daisy-lower" },
  { name: "Kubo", category: "Display", image: "images/newkubo.jpg", description: "Modern design with a minimal footprint, ideal for high-traffic areas in cafes.", route: "/kubo" },
  { name: "Vista", category: "Display", image: "images/vista2.jpg", description: "This model offers versatile display options for coffee shops. Its sleek design integrates seamlessly into modern settings.", route: "/vista" },
  { name: "E-Line", category: "Display", image: "images/neweline.jpg", description: "Elegant design offering compact solutions for a modern, stylish coffee setup.", route: "/e-line" },
  { name: "Daisy", category: "Display", image: "images/daisy22.jpg", description: "A versatile and functional line with all the options for the food retail.", route: "/daisy-upper" },
  { name: "Urban", category: "More solutions", image: "images/urban.jpg", description: "Urban-styled model offering practical and compact design suitable for modern coffee environments.", route: "/urban" },
  { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "A convenient solution for online orders with in-store pickup for butcher shops.", route: "/CLICK&COLLECT" },

  // { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistagrabgo.jpg", description: "Perfect for fast-service coffee shops with a modern, grab-and-go concept.", route: "/vista-grab-and-go" },
  // { name: "Futuro 2", category: "Semi-Verticals", image: "images/futuro2.jpg", description: "Futuristic design with compact, efficient use of space, ideal for high-demand settings.", route: "/futuro2" },
  // { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "A premium model designed to suit the needs of modern coffee shops with high foot traffic.", route: "/victory" }
];

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

function Bakerypastery() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();
  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
         {/* Hero Section */}
         <section
           className="relative text-center w-full h-[600px]"
           style={{
             backgroundImage: "url('images/model.jpg')",
             backgroundSize: "cover",
             backgroundPosition: "center",
             backgroundRepeat: "no-repeat",
           }}
         >
          
         </section>
   
         {/* Models Display */}
         <section className="px-6 py-12 md:px-32">
           <section className="px-6 md:px-32">
           <div className="flex flex-col items-center justify-center text-black p-6">
             <h1 className="text-3xl mb-4 md:text-4xl text-center">Bakery & Pastry</h1>
             <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
             Find here everything you need for the exhibition and service of Bread and Confectionery. The most innovative solutions for modern Bakeries and Patisseries.
             </p>
           </div>
   
           <div className="flex justify-center">
             <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
             <button className="block py-1 pl-4 hover:underline uppercase mt-6">Bakery & Pastry</button>
           </div>
         </section>
   
           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
             {currentModels.map((model, index) => (
               <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
                 <div
                   className="relative w-full h-80 mb-4"
                   style={{
                     backgroundImage: `url(${model.image})`,
                     backgroundSize: "contain", // Ensures no cuts, full image shown
                     backgroundPosition: "center",
                     backgroundRepeat: "no-repeat",
                     height: "300px",
                   }}
                 ></div>
                 <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
                 {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
                 <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
   
                 {/* Small icons under each model */}
                 <div className="flex justify-center gap-4">
                   {icons.map((icon, index) => (
                     <div key={index} className="text-2xl">
                       {icon.icon}
                     </div>
                   ))}
                 </div>
               </div>
             ))}
           </div>
   
           {/* Pagination */}
           <div className="flex justify-center mt-10">
             <button
               onClick={() => handlePageChange(currentPage - 1)}
               disabled={currentPage === 1}
               className="px-4 py-2 bg-gray-800 text-white rounded-l"
             >
               Previous
             </button>
             <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
             <button
               onClick={() => handlePageChange(currentPage + 1)}
               disabled={currentPage === totalPages}
               className="px-4 py-2 bg-gray-800 text-white rounded-r"
             >
               Next
             </button>
           </div>
         </section>
       </div>
     );
   }

export default Bakerypastery;
